(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1135px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Function to close all fullscreen dropdowns
  function closeAllFullscreenDropdowns() {
    const openDropdowns = document.querySelectorAll('header-menu details[open]');
    openDropdowns.forEach(details => {
      const headerMenu = details.closest('header-menu');
      const summary = headerMenu?.querySelector('summary');
      if (details.hasAttribute('open')) {
        details.removeAttribute('open');
        summary?.setAttribute('aria-expanded', 'false');
      }
    });
    // Re-enable body scroll
    document.body.style.overflow = '';
  }

  // Track if dropdown is being opened to prevent immediate closure
  let isOpeningDropdown = false;
  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let scrollThreshold = 5; // Minimum scroll distance to trigger close

  // Close fullscreen dropdowns when clicking outside
  document.addEventListener('click', function(event) {
    // Don't close if we're clicking on a summary element or inside header-menu (opening/toggling dropdown)
    const clickedHeaderMenu = event.target.closest('header-menu');
    const clickedSummary = event.target.closest('header-menu summary');
    
    if (clickedSummary || (clickedHeaderMenu && clickedHeaderMenu.contains(event.target))) {
      // Allow the dropdown to open/toggle naturally
      isOpeningDropdown = true;
      setTimeout(() => {
        isOpeningDropdown = false;
      }, 300); // Give dropdown time to open
      return;
    }

    // Only close if clicking outside all header menus
    const openDropdowns = document.querySelectorAll('header-menu details[open] .header__submenu--fullscreen');
    if (openDropdowns.length > 0) {
      const clickedInsideAnyDropdown = Array.from(openDropdowns).some(dropdown => {
        const headerMenu = dropdown.closest('header-menu');
        return headerMenu && headerMenu.contains(event.target);
      });
      
      if (!clickedInsideAnyDropdown) {
        closeAllFullscreenDropdowns();
      }
    }
  });

  // Close fullscreen dropdowns on scroll (with debounce and threshold)
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    const hasOpenDropdown = document.querySelector('header-menu details[open] .header__submenu--fullscreen');
    if (hasOpenDropdown && !isOpeningDropdown) {
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDelta = Math.abs(currentScrollTop - lastScrollTop);
      
      // Only close if scroll is significant (not from ScrollSmoother micro-scrolls)
      if (scrollDelta > scrollThreshold) {
        // Clear any existing timeout
        clearTimeout(scrollTimeout);
        
        // Debounce the close to prevent flickering
        scrollTimeout = setTimeout(() => {
          closeAllFullscreenDropdowns();
        }, 100);
      }
      
      lastScrollTop = currentScrollTop;
    } else {
      lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    }
  }, { passive: true });

  // Prevent body scroll when fullscreen dropdown is open and track opening state
  document.addEventListener('DOMContentLoaded', function() {
    const headerMenus = document.querySelectorAll('header-menu');
    headerMenus.forEach(headerMenu => {
      const details = headerMenu.querySelector('details');
      if (details) {
        details.addEventListener('toggle', function() {
          const hasFullscreen = this.querySelector('.header__submenu--fullscreen');
          if (this.hasAttribute('open') && hasFullscreen) {
            // Prevent body scroll when fullscreen dropdown is open
            document.body.style.overflow = 'hidden';
            // Mark that dropdown is opening to prevent scroll handler from closing it
            isOpeningDropdown = true;
            setTimeout(() => {
              isOpeningDropdown = false;
            }, 500); // Give dropdown time to fully open
          } else {
            // Re-enable body scroll when dropdown closes
            document.body.style.overflow = '';
            isOpeningDropdown = false;
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
